import PropTypes from 'prop-types';

export const RevealTypes = {
  alt_content_image_url: PropTypes.string,
  body: PropTypes.string,
  content_image_url: PropTypes.string,
  instruction: PropTypes.string,
  reveal_id: PropTypes.number,
  subject: PropTypes.string,
};
